module.exports = __webpack_public_path__ + "static/rabbyrinth_kae2-a7de3b8bab21023f213b42b33b3a520a.jpg";